import { Context, Data } from 'effect';
import type { Effect, Layer, Option } from 'effect';

import { ErrorTag } from '../../data/error';
import type { CookiesStore } from '../cookies/CookiesStore';
import { ContextTag } from '../context';

export class GetOrderTokenError extends Data.TaggedError(ErrorTag.OrderTokenGetError)<{
  message: string;
  cause?: unknown;
}> {}

export class SetOrderTokenError extends Data.TaggedError(ErrorTag.OrderTokenSetError)<{
  message: string;
  cause?: unknown;
}> {}

export type OrderTokenService = {
  readonly getToken: Effect.Effect<Option.Option<string>, GetOrderTokenError>;
  readonly setToken: (token: string) => Effect.Effect<void, SetOrderTokenError>;
  readonly removeToken: Effect.Effect<void, SetOrderTokenError>;
};

export class OrderToken extends Context.Service<OrderToken, OrderTokenService>()(
  ContextTag.OrderToken
) {
  declare static Live: Layer.Layer<OrderToken, never, CookiesStore>;
}
